import style from "./mailVerify.module.css";
import Lottie from "react-lottie";
import successAnim from "../../../lotties/mail_verify_sucess.json";
import bgImage from "../../../assets/img/Email_campaign_pana.png";
import { useLocation, useNavigate } from "react-router-dom";
import { post } from "../../../adapters/xhr/api";
import { useState } from "react";
import {
  forgotPassowrd,
  profileVerificationEmail,
} from "../../../adapters/apis/auth/auth";

function MailVerifyProfile() {
  const navigate = useNavigate();
  const url = "api/validateEmail";
  const [errMessage, setErrMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const query = new URLSearchParams(location.search);
  const email = query.get("email");

  const defaultOptions = {
    loop: true,
    autoplay: true,
    speed: 1,
    animationData: successAnim,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  // const handleResend = async (e) => {
  function handleResend() {
    // e.preventDefault();
    setLoading(true);
    setErrMessage("");

    try {
      profileVerificationEmail({ email: email })
        .then((res) => {
          console.log("====================================");
          console.log(res.data);
          console.log("====================================");
          setErrMessage(res.data.message);
          navigate(`/mail-verify-profile?email=${email}`);
          setLoading(false);
        })
        .catch((error) => {
          console.log("==errorerrorerror==================================");
          console.log(error);
          console.log("====================================");
          setErrMessage(
            error?.response?.data?.message || "حدث خطأ أثناء إرسال البريد",
          );
          setLoading(false);
        });
    } catch (error) {
      console.error("Resend failed:", error);
      setLoading(false);
    }
    // try {
    //   const response = await post("api/validateEmail", {}, {});
    //   console.log("Resend response:", response.data);
    // } catch (error) {
    //   console.error("Resend failed:", error);
    // }
  }

  return (
    <div className={style.verifyContainer}>
      <div className={style.verifyCard}>
        <img src={bgImage} className={style.verifyBg} alt="" />

        <Lottie options={defaultOptions} />

        <h3 className={style.verifyTitle}>
          تم إرسال بريد تفعيل البريد الإلكتروني الخاص بك إلى بريدك الإلكتروني
        </h3>

        <button
          className={style.verifyBtn}
          onClick={() =>
            navigate(
              location?.state?.navigateToDecleration
                ? "/tax-declaration/list-data"
                : "/profile",
            )
          }
        >
          العودة إلى الشاشة السابقة
        </button>

        <a
          href="#"
          className={loading ? style.disabledLink : style.verifyResend}
          // className={style.verifyResend}
          onClick={handleResend}
          disabled={loading}
        >
          إعادة إرسال بريد التحقق من البريد الإلكتروني
        </a>
        {errMessage && (
          <div className="alert alert-primary mt-4" role="alert">
            {errMessage}
          </div>
        )}
      </div>
    </div>
  );
}

export default MailVerifyProfile;
